import { render } from "./ConnectionCard.vue?vue&type=template&id=491df37e&scoped=true"
const script = {}

import "./ConnectionCard.vue?vue&type=style&index=0&id=491df37e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-491df37e"]])

export default __exports__